import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  PharmacyDetails,
} from '../../../../core/models/patient/pharmacyDetails';
import { PatientService } from '../../../../core/services/v2/patient.service';
import {
  WindowLoaderService,
} from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-pharmacy-preferences',
  templateUrl: './pharmacy-preferences.component.html',
  styleUrls: ['./pharmacy-preferences.component.scss']
})
export class PharmacyPreferencesComponent implements OnInit {
  @Input() isParams = false;
  @Input() editEnable: boolean = true;
  @Input() pharmacyPreferences: PharmacyDetails[];
  @Output() toggleEditEvent = new EventEmitter();
  @Input() patientId: number;

  constructor(private patientService: PatientService,
    private loaderService: WindowLoaderService  ) { }

  ngOnInit() {
  }
  displayedColumnsTrial: string[] = [
    "no","PreferedPharmacy","PharmacyPhone","PharmacyAddress","Timings","ActionButton",
  ];
  toggleEdit(pharmacyPreferences: PharmacyDetails) {
    console.log(pharmacyPreferences)
    if (pharmacyPreferences) {
      this.toggleEditEvent.emit(pharmacyPreferences);

    } else{
      this.toggleEditEvent.emit(new PharmacyDetails());}

  }

  deletePharmacy(npi: string, ind: number) {
    this.loaderService.blockWithLoader(this.patientService.deletePharmacyPreference(this.patientId, npi))
      .subscribe(
      (res) => {
        if (res.isSuccess) {
          this.pharmacyPreferences.splice(ind, 1);
        } else
          console.error(res);
      },
      (error) => { console.error(error); }
    );

  }
}
